import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'

export type CreateOrdoclicEntityDialogProps = {
  isCreating: boolean
  onClose: () => void
  onCreateEntity: (values: { name: string; finess?: string }) => void
  open: boolean
  establishmentName: string
}

export function CreateOrdoclicEntityDialog(props: CreateOrdoclicEntityDialogProps) {
  const { isCreating, onClose, onCreateEntity, open, establishmentName } = props
  const { t } = useTranslation()
  const [finess, setFiness] = useState('')

  const handleSubmit = () => {
    onCreateEntity({ name: establishmentName, finess })
  }

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>{t('page.superAdmin.createOrdoclicEntityDialog.title')}</DialogTitle>
      <DialogContent sx={{ minWidth: '500px', minHeight: '200px' }}>
        <TextField
          fullWidth
          label={t('page.superAdmin.createOrdoclicEntityDialog.finess')}
          value={finess}
          onChange={(e) => setFiness(e.target.value)}
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose}>
          {t('common:button.cancel.label')}
        </Button>
        <LoadingButton loading={isCreating} onClick={handleSubmit} variant="contained">
          {t('common:button.submit.label')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default CreateOrdoclicEntityDialog
